'use client'

import { useStoreGclid } from '../utils/tracking'

// Headless component that captures the Google Ads gclid tracking param from the landing
// URL into session storage. Mounted once in the root layout so it runs on every marketplace page.
export function GclidTracker() {
  useStoreGclid()

  return null
}
